import { useNavigate } from '@tanstack/react-router';
import { type LogoutMutationError, useLogout } from '@/entities/authentication/api/generated/api';
import { logout } from '@/entities/session/api/sessionApi';
import { useFormDirtyStore } from '@/shared/stores/form-dirty-store';
import { toast } from '@/shared/ui';

export const useLogoutAction = () => {
  const navigate = useNavigate();

  return useLogout({
    mutation: {
      onSuccess: () => {
        // entities/sessionのlogout()でトークンクリア + キャッシュクリア + セッションクリア
        logout();

        // フォームの編集状態をリセットしてLeavePageAlertのブロックを解除
        useFormDirtyStore.getState().setIsDirty(false);

        toast.success('ログアウトしました');

        // ログインページへリダイレクト
        navigate({ to: '/login' });
      },
      onError: (error: LogoutMutationError) => {
        // エラーでもローカル状態はクリアする
        logout();

        // フォームの編集状態をリセットしてLeavePageAlertのブロックを解除
        useFormDirtyStore.getState().setIsDirty(false);

        const message = error.response?.data?.message || 'ログアウトに失敗しました';
        toast.error(message);

        navigate({ to: '/login' });
      },
    },
  });
};
